import React from 'react';
import OrderForm from '../components/OrderForm';
import { useNavigate } from 'react-router-dom';
import { logout, getUser } from '../services/auth';
import './DealerOrderPage.css';
import BrandLogo from '../components/BrandLogo';

const DealerOrderPage: React.FC = () => {
  const navigate = useNavigate();
  const user = getUser();

  const handleLogout = () => {
    logout();
    window.location.href = '/';
  };

  return (
    <div>
      <header className="app-header">
        <div className="container">
          <span style={{ marginRight: 'auto' }}>
            <BrandLogo height={17} withIcon />
          </span>
          <div className="header-actions">
            <button
              onClick={() => navigate('/orders')}
              className="btn btn-secondary my-orders-btn-desktop"
            >
              Meine Bestellungen
            </button>
            <span className="user-info">Angemeldet als: {user?.username}</span>
            <button onClick={handleLogout} className="btn btn-secondary">
              Abmelden
            </button>
          </div>
        </div>
      </header>
      <div className="container" style={{ padding: '0px' }}>
        <div className="my-orders-btn-mobile">
          <button onClick={() => navigate('/orders')} className="btn btn-secondary">
            Meine Bestellungen
          </button>
        </div>
      </div>
      <OrderForm />
    </div>
  );
};

export default DealerOrderPage;
